import React, { forwardRef } from "react";

const SimpleSelect = forwardRef(
  (
    {
      className = "",
      options = [],
      error,
      label,
      placeholder = "Select an option",
      ...props
    },
    ref
  ) => {
    const baseClass = `flex h-10 w-full rounded-md border bg-background px-3 py-2 text-base ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm ${
      error
        ? "border-destructive focus-visible:ring-destructive"
        : "border-input focus-visible:ring-ring"
    }`;

    return (
      <div className="w-full">
        <select className={baseClass + " " + className} ref={ref} {...props}>
          <option value="">{placeholder}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error && <p className="text-sm text-destructive mt-1">{error}</p>}
      </div>
    );
  }
);

SimpleSelect.displayName = "SimpleSelect";

export default SimpleSelect;


